import React from 'react';
import './FooterSection.css';
import { useLanguage } from '../hooks/useLanguage';

const FooterSection = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <p>
        &copy; {new Date().getFullYear()} {t.hero.name}. {t.footer.rights}
      </p>
    </footer>
  );
};

export default FooterSection;
